export enum FeedbackType {
    None = 0,
    Single = 1,
    CorrectIncorrect = 2,
}
